var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessCodeOutline = function SvgAccessCodeOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.345 6H4.655c-1.05 0-1.905.855-1.905 1.905v8.205c0 1.05.855 1.905 1.905 1.905h15.69c1.05 0 1.905-.855 1.905-1.905V7.905c0-1.05-.855-1.905-1.905-1.905Zm.684 10.11a.683.683 0 0 1-.684.684H4.655a.683.683 0 0 1-.684-.684V7.905c0-.379.305-.684.684-.684h15.69c.379 0 .684.305.684.684v8.205Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.268 10.481v3.053M5.95 12.764l2.649-1.526M8.599 12.764l-2.65-1.526M12.506 10.481v3.053M11.188 12.764l2.637-1.526M13.825 12.764l-2.637-1.526M17.745 10.481v3.053M16.426 12.764l2.637-1.526M19.063 12.764l-2.637-1.526",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
export default SvgAccessCodeOutline;